import React, { useContext } from 'react'
import { AuthContext } from '../../context/auth-context'

import Form from 'react-bootstrap/Form'
import { AuthButtonStyles } from './styled'

const Auth = (props) => {
  const authContext = useContext(AuthContext)

  const passwordRef = React.createRef()

  const submitHandler = (event) => {
    event.preventDefault()
    const fieldVal = passwordRef.current.value
    const passwordToken = fieldVal.toLowerCase().indexOf('bearer ') === 0
      ? fieldVal
      : `Bearer ${fieldVal}`

    authContext.handleLogin(passwordToken)

    // if (email.trim().length === 0 || password.trim().length === 0) {
    //   return
    // }
  }

  return (
    <Form onSubmit={submitHandler}>
      <Form.Group controlId='formBasicPassword'>
        <Form.Label>Bearer Token</Form.Label>
        <Form.Control type='password' placeholder='Password' ref={passwordRef} />
      </Form.Group>
      <AuthButtonStyles variant='primary' type='submit'>
        Submit
      </AuthButtonStyles>
    </Form>
  )
}

export default Auth
